export default {"src":"/_next/static/media/money.fc17388d.svg","height":30,"width":30};